/**
 * Shared percent-of-normal → Tailwind text class for regional report tables.
 * Bins mirror the OutlookGauge BANDS so table text and gauge palette agree.
 */
export function percentColor(value: number | null): string {
  if (value == null) return 'text-gray-400';
  if (value < 75) return 'text-red-600 font-semibold';
  if (value < 90) return 'text-orange-600 font-semibold';
  if (value <= 110) return 'text-gray-900';
  if (value <= 125) return 'text-cyan-600 font-semibold';
  return 'text-blue-600 font-semibold';
}
